export default "__VITE_ASSET__f4df0ee2__"